import React from "react";


function Particle() {
  return (
    <div></div>
  );
}

export default Particle;
